import { Box } from "@mui/material";
import React from "react";
import SQLEditor from "./SQLEditor";

interface SQLFormatProps {
  error?: any;
  setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  mergeQuerycolumns?: any;
  isFinalQuery?: any;
  dialogType?: string;
  queryBuilderType?: string;
  mergeQueryType?: string;
  label?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  showAvailableVariables?: boolean; // New prop to control AvailableVariables display
  showResourceColumnsChips?: boolean; // New prop to control ResourceColumnsChips display
  // Hides the "Available Columns" section below the editor (see SQLEditor).
  hideAvailableColumns?: boolean;
  // Stable per-instance key used to persist editor UI state (expansion, cursor).
  editorStateKey?: string;
  // Custom state management props for multi-query builder
  customValue?: string;
  customOnChange?: (value: string) => void;
  customEditorRef?: any;
  customOnBlur?: () => void;
  // Optional: opens the standalone pop-out editor (rendered in the toolbar).
  onPopOut?: () => void;
}

const SQLFormat: React.FC<SQLFormatProps> = ({
  error,
  setErrors,
  mergeQuerycolumns,
  isFinalQuery,
  dialogType,
  queryBuilderType,
  mergeQueryType,
  label,
  onFocus,
  onBlur,
  showAvailableVariables = true, // Default to true for backward compatibility
  showResourceColumnsChips = true, // Default to true for backward compatibility
  hideAvailableColumns = false, // Default to false for backward compatibility
  editorStateKey,
  // Custom state management props
  customValue,
  customOnChange,
  customEditorRef,
  customOnBlur,
  onPopOut,
}) => {
  return (
    <Box>
      <Box>
        <SQLEditor
          error={error}
          setErrors={setErrors}
          mergeQuerycolumns={mergeQuerycolumns}
          isFinalQuery={isFinalQuery}
          dialogType={dialogType ?? ""}
          queryBuilderType={queryBuilderType ?? ""}
          mergeQueryType={mergeQueryType}
          label={label}
          onFocus={onFocus}
          onBlur={onBlur}
          showAvailableVariables={showAvailableVariables}
          showResourceColumnsChips={showResourceColumnsChips}
          hideAvailableColumns={hideAvailableColumns}
          editorStateKey={editorStateKey}
          customValue={customValue}
          customOnChange={customOnChange}
          customEditorRef={customEditorRef}
          customOnBlur={customOnBlur}
          onPopOut={onPopOut}
        />
      </Box>
    </Box>
  );
};

export default SQLFormat;
